import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { LookerDashboard } from 'lumen/models';

export default class MarketCustomReportingTemplatesRoute extends Route {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare store: Services['store'];

  loadTemplatesDashboardsTask = task({ restartable: true }, async () => {
    try {
      return await this.store.query<LookerDashboard>('looker-dashboard', {
        namespace: 'api/v3',
        typeKey: 'custom-reporting/dashboards/templates',
      });
    } catch (error) {
      this.errorTracking.captureException(error);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
      return undefined;
    }
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const model = {
      templates: this.loadTemplatesDashboardsTask,
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    model.templates.perform();

    return model;
  }
}
